<template>

  <form @submit.prevent>
     <CModal
        :title.sync="title"
        color="info"
        size="lg"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <CInput v-model="form.booking_id"  label="Booking ID" placeholder=""  />
          </CCol>
        </CRow>

     
          <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton type="submit" v-on:click.prevent="submit(form.booking_id)"  variant="outline" color="info">Submit</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import event from '@/services/event';

import moment from 'moment';

export default {
name: 'cancelation',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      value:'',
      form:{
        booking_id:'',
      },
      
      largeModal:false,
      largeModal1:false,
    }
    
  },

  created () {
      var self = this;
      EventBus.$on('OPEN_MODAL_EVENT_CANCEL_PARTICIPANT', (params) => {
      //if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.booking_id = "";
        
      //}
    });
     
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){

    },
    filterKey(e){
      const key = e.key;

      // If is '.' key, stop it
      if (key === '.')
        return e.preventDefault();
      
      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e')
        return e.preventDefault();
    },
    
    // This can also prevent copy + paste invalid character
    filterInput(e){
      e.target.value = e.target.value.replace(/[^0-9]+/g, '');
    },
    submit(id){
      this.show = false;
      event.cancelParticipant(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        //self.loadData()
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
   
  }
}
</script>

<style>

</style>